module.exports = __webpack_public_path__ + "img/smoke.d06b0997.svg";